import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { MobileTransactionDto, ShopBankOfferDto, ShopConfigDto, StripeCheckoutDto } from '@mos/api/bank/dto-client'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export abstract class BankService {
	protected readonly http = inject(HttpClient)

	protected getApiOffers(): Observable<ShopConfigDto> {
		return this.http.get<ShopConfigDto>('@api/bank/offers')
	}

	abstract getOffers(): Observable<ShopConfigDto>

	abstract consumeOffer(offer: ShopBankOfferDto): Observable<StripeCheckoutDto | undefined>

	protected creditMobileTransaction(transaction: MobileTransactionDto) {
		return this.http.post('@api/bank/mobile/credit', transaction)
	}
}
